import React from 'react';
import 'date-fns';
import { useStyles } from './styles';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import frLocale from "date-fns/locale/pt-BR";
import DateFnsUtils from '@date-io/date-fns';
import { useMediaQuery, useTheme, createMuiTheme, ThemeProvider, TextField } from '@material-ui/core';
import MyTheme from '../../theme';

const Theme = createMuiTheme({
    palette: {
        primary: {
            main: MyTheme.palette.primary.main
        },
        secondary: {
            main: MyTheme.palette.secondary.main
        }
    }
})

export const KDatePicker = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down('sm'));

    const handleChangeData = (xdate) => {
        if (props.setDate) {
            props.setDate(xdate);
        }
        if (props.setValueArray) {
            let array = [...props.valueArray];
            array[props.index][props.tipoArray] = xdate;
            props.setValueArray(array);
        }
        if (props.eventOnChange) {
            props.eventOnChange({ target: { name: props.name, value: xdate } });
        }
        if (props.onChange) {
            props.onChange(props.name, xdate);
        }
        if (props.onChangeChild) {
            props.onChangeChild();
        }
    }

    return (
        <div style={{width: '100%'}}>
            <ThemeProvider theme={Theme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                    <KeyboardDatePicker
                        className={classes.root}
                        autoOk
                        disabled={props.disabled}
                        initialFocusedDate={props.initialFocusedDate || null}
                        disablePast={props.disablePast || false}
                        minDate={props.minDate || new Date(1900, 0, 1)}
                        minDateMessage={'A data não deve ser anterior à data mínima'}
                        required={props.required}
                        fullWidth
                        variant={responsive ? 'dialog' : 'inline'}
                        orientation="portrait"
                        cancelLabel="Cancelar"
                        inputVariant="outlined"
                        margin="dense"
                        invalidDateMessage="Formato de data inválido!"
                        name={props.name}
                        id="date-picker-dialog"
                        TextFieldComponent={TextField}
                        label={props.label}
                        format="dd/MM/yyyy"
                        value={props.date}
                        onChange={handleChangeData}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </div>
    )
};

export default KDatePicker

